import { emailFormCtaClick, isMobileViewport, sendFooterData } from '@nulo/gtm';

/**
 * @extends {HTMLElement}
 */
class NuloFooter extends HTMLElement {
  /** @type {AbortController | null} */
  #abortController = null;

  connectedCallback() {
    if (this.dataset.bound === 'true') return;
    this.dataset.bound = 'true';

    this.#abortController = new AbortController();
    const { signal } = this.#abortController;

    this.querySelectorAll('[data-footer-accordion]').forEach((button) => {
      button.addEventListener('click', (event) => this.#toggleAccordion(event), { signal });
    });

    this.querySelectorAll('[data-footer-link]').forEach((link) => {
      link.addEventListener('click', () => sendFooterData(), { signal });
    });

    const emailCta = this.querySelector('[data-footer-email-cta]');
    emailCta?.addEventListener(
      'click',
      () => emailFormCtaClick(isMobileViewport(), 'footer'),
      { signal }
    );

    const cookieSettings = this.querySelector('[data-footer-cookie-settings]');
    cookieSettings?.addEventListener('click', () => this.#openCookieSettings(), { signal });
  }

  disconnectedCallback() {
    this.#abortController?.abort();
    this.#abortController = null;
  }

  /**
   * @param {Event} event
   */
  #toggleAccordion(event) {
    const button = event.currentTarget;
    if (!(button instanceof HTMLButtonElement)) return;

    const item = button.closest('[data-footer-accordion-item]');
    const panelId = button.getAttribute('aria-controls');
    const panel = panelId ? this.querySelector(`#${CSS.escape(panelId)}`) : null;

    if (!(item instanceof HTMLElement) || !(panel instanceof HTMLElement)) return;

    const isOpen = item.classList.contains('is-open');

    this.querySelectorAll('[data-footer-accordion-item].is-open').forEach((openItem) => {
      if (openItem === item) return;
      openItem.classList.remove('is-open');
      const openButton = openItem.querySelector('[data-footer-accordion]');
      const openPanelId = openButton?.getAttribute('aria-controls');
      const openPanel = openPanelId ? this.querySelector(`#${CSS.escape(openPanelId)}`) : null;
      if (openButton instanceof HTMLButtonElement) openButton.setAttribute('aria-expanded', 'false');
      if (openPanel instanceof HTMLElement) openPanel.hidden = true;
    });

    item.classList.toggle('is-open', !isOpen);
    panel.hidden = isOpen;
    button.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
  }

  #openCookieSettings() {
    if (typeof window.cookiehub?.openSettings === 'function') {
      window.cookiehub.openSettings();
    }
  }
}

if (!customElements.get('nulo-footer')) {
  customElements.define('nulo-footer', NuloFooter);
}
